import {Component, OnDestroy, OnInit, ViewEncapsulation, Input} from "@angular/core";
import {MatButtonModule} from "@angular/material/button";
import {MatIconModule} from "@angular/material/icon";
import {ActivatedRoute, Router, RouterOutlet} from "@angular/router";
import {DavesaAlertBannerComponent} from "@davesa/components/alert-banner";
import {DavesaFullscreenComponent} from "@davesa/components/fullscreen";
import {DavesaLoadingBarComponent} from "@davesa/components/loading-bar";
import {
    DavesaHorizontalNavigationComponent,
    DavesaNavigationService,
    DavesaVerticalNavigationComponent,
} from "@davesa/components/navigation";
import {DavesaMediaWatcherService} from "@davesa/services/media-watcher";
import {NavigationService} from "app/core/navigation/navigation.service";
import {Navigation} from "app/core/navigation/navigation.types";
import {ClinicNowComponent} from "app/layout/common/clinic-now/clinic-now.component";
import {SupportLinksComponent} from "app/layout/common/support-links/support-links.component";
import {LanguagesComponent} from "app/layout/common/languages/languages.component";
import {SearchComponent} from "app/layout/common/search/search.component";
import {SettingsComponent} from "app/layout/common/settings/settings.component";
import {ShortcutsComponent} from "app/layout/common/shortcuts/shortcuts.component";
import {LoginUserComponent} from "app/layout/common/login-user/login-user.component";
import {Subject, takeUntil} from "rxjs";
import { NotificationsComponent } from "app/layout/common/notifications/notifications.component";

@Component({
    selector: "enterprise-layout",
    templateUrl: "./enterprise.component.html",
    encapsulation: ViewEncapsulation.None,
    imports: [
        DavesaLoadingBarComponent,
        DavesaVerticalNavigationComponent,
        MatButtonModule,
        MatIconModule,
        // LanguagesComponent,
        DavesaFullscreenComponent,
        SearchComponent,
        NotificationsComponent,
        DavesaHorizontalNavigationComponent,
        RouterOutlet,
        ClinicNowComponent,
        SupportLinksComponent,
        DavesaAlertBannerComponent,
        SettingsComponent,
    ]
})
export class EnterpriseLayoutComponent implements OnInit, OnDestroy {
    @Input() showClinicNow: boolean = true;
    isScreenSmall: boolean;
    navigation: Navigation;
    private _unsubscribeAll: Subject<any> = new Subject<any>();

    /**
     * Constructor
     */
    constructor(
        private _activatedRoute: ActivatedRoute,
        private _router: Router,
        private _navigationService: NavigationService,
        private _davesaMediaWatcherService: DavesaMediaWatcherService,
        private _davesaNavigationService: DavesaNavigationService
    ) {}

    // -----------------------------------------------------------------------------------------------------
    // @ Accessors
    // -----------------------------------------------------------------------------------------------------

    /**
     * Getter for current year
     */
    get currentYear(): number {
        return new Date().getFullYear();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void {
        // Subscribe to navigation data
        this._navigationService.navigation$
        .pipe(takeUntil(this._unsubscribeAll))
        .subscribe((navigation: Navigation) => {
            this.navigation = navigation;
        });

        // Subscribe to media changes
        this._davesaMediaWatcherService.onMediaChange$
        .pipe(takeUntil(this._unsubscribeAll))
        .subscribe(({matchingAliases}) => {
            // Check if the screen is small
            this.isScreenSmall = !matchingAliases.includes("md");
        });
    }

    /**
     * On destroy
     */
    ngOnDestroy(): void {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Toggle navigation
     *
     * @param name
     */
    toggleNavigation(name: string): void {
        // Get the navigation
        const navigation = this._davesaNavigationService.getComponent<DavesaVerticalNavigationComponent>(name);

        if (navigation) {
            // Toggle the opened status
            navigation.toggle();
        }
    }
}
